import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from '../layout/Footer';

export default function BlogLayout({ children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-dark-bg">
      <header className="border-b border-gray-200 dark:border-dark-border bg-white dark:bg-dark-bg sticky top-0 z-10">
        <div className="mx-auto max-w-6xl px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Link
                to="/"
                className="text-2xl font-black tracking-tight text-gray-900 dark:text-white font-rajdhani"
              >
                SureDox
              </Link>
              <span className="text-gray-300 dark:text-gray-600">|</span>
              <Link
                to="/blog"
                className="text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
              >
                Blog
              </Link>
            </div>

            <Link
              to="/"
              className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1">
        {children}
      </main>

      <Footer variant="default" />
    </div>
  );
}
